import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import './DTResultados.css';
import DTViewer from './DTViewer';

const sampleData = [
  {
    codigoAduana: '5001',
    numeroViaje: '6075',
    fechaSalida: '14/02/2026',
    referenciaDT: '262373793',
    referenciaDTPadre: '',
    tipo: 'MBL 23',
    uso: 'AEJEA',
    lugarEmbarque: 'VELAG',
    lugarDesembarque: '',
    estatus: 'MST DEG',
    indicadorDividir: '',
    nombreConsignatario: 'CARGA EXPRESS UNICOR C.A',
  },
];

function DTResultados({ onClose, savedDTs = [] }) {
  const allData = [...sampleData, ...savedDTs];
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: null, y: null });
  const [selectedRow, setSelectedRow] = useState(null);
  const [contextMenu, setContextMenu] = useState(null);
  const [showViewer, setShowViewer] = useState(false);
  const dragOffset = useRef({ x: 0, y: 0 });
  const dialogRef = useRef(null);

  const handleMouseDown = (e) => {
    if (dialogRef.current) {
      const rect = dialogRef.current.getBoundingClientRect();
      dragOffset.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };
      setIsDragging(true);
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setPosition({
        x: e.clientX - dragOffset.current.x,
        y: e.clientY - dragOffset.current.y,
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleRowContextMenu = (e, i) => {
    e.preventDefault();
    setSelectedRow(i);
    setContextMenu({ x: e.clientX, y: e.clientY });
  };

  const style = position.x !== null
    ? { left: position.x, top: position.y, transform: 'none' }
    : {};

  return ReactDOM.createPortal(
    <div
      className="dt-resultados-overlay"
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      <div className="dt-resultados-window" ref={dialogRef} style={style}>
        {/* Barra de título */}
        <div className="dt-resultados-titlebar" onMouseDown={handleMouseDown}>
          <span className="dt-resultados-title">D/T buscador</span>
          <button className="dt-resultados-close" onClick={onClose}>×</button>
        </div>

        {/* Mensaje informativo */}
        <div className="dt-resultados-info">
          <span className="dt-resultados-info-icon">ℹ️</span>
          <span className="dt-resultados-info-text">
            Un documento encontrado! Por favor seleccione un documento y una acción del menú local
          </span>
        </div>

        {/* Tabla de resultados */}
        <div className="dt-resultados-table-container">
          <table className="dt-resultados-table">
            <thead>
              <tr>
                <th>Código Aduana</th>
                <th>Número de viaje</th>
                <th>Fecha de salida</th>
                <th>Referencia D/T</th>
                <th>Referencia D/T padre</th>
                <th>Tipo</th>
                <th>Uso</th>
                <th>Lugar de embarque</th>
                <th>Lugar de desembarque</th>
                <th>Estatus</th>
                <th>Indicador Dividir</th>
                <th>Nombre Consignatario</th>
              </tr>
            </thead>
            <tbody>
              {allData.map((row, i) => (
                <tr
                  key={i}
                  className={selectedRow === i ? 'selected' : ''}
                  onClick={() => { setSelectedRow(i); setContextMenu(null); }}
                  onContextMenu={(e) => handleRowContextMenu(e, i)}
                >
                  <td>{row.codigoAduana}</td>
                  <td>{row.numeroViaje}</td>
                  <td>{row.fechaSalida}</td>
                  <td>{row.referenciaDT}</td>
                  <td>{row.referenciaDTPadre}</td>
                  <td>{row.tipo}</td>
                  <td>{row.uso}</td>
                  <td>{row.lugarEmbarque}</td>
                  <td>{row.lugarDesembarque}</td>
                  <td>{row.estatus}</td>
                  <td>{row.indicadorDividir}</td>
                  <td>{row.nombreConsignatario}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="dt-resultados-empty-area" />
        </div>

        {/* Barra inferior */}
        <div className="dt-resultados-bottombar">
          <div className="dt-resultados-bottom-icons">
            <button className="dt-resultados-icon-btn" title="Información">❓</button>
            <button className="dt-resultados-icon-btn" title="Nuevo">📄</button>
            <button className="dt-resultados-icon-btn" title="Copiar">📋</button>
            <button className="dt-resultados-icon-btn" title="Imprimir">🖨️</button>
          </div>
          <div className="dt-resultados-bottom-nav">
            <button className="dt-resultados-nav-btn" title="Anterior">◀◀</button>
            <button className="dt-resultados-nav-btn" title="Siguiente">▶▶</button>
          </div>
        </div>
      </div>
      {contextMenu && ReactDOM.createPortal(
        <div
          className="dt-resultados-context-overlay"
          onClick={() => setContextMenu(null)}
          onContextMenu={(e) => { e.preventDefault(); setContextMenu(null); }}
        >
          <div
            className="dt-resultados-context-menu"
            style={{ top: contextMenu.y, left: contextMenu.x }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="dt-resultados-context-item"
              onClick={() => {
                setShowViewer(true);
                setContextMenu(null);
              }}
            >
              <span className="dt-resultados-context-icon">📋</span> Ver
            </button>
            <button
              className="dt-resultados-context-item"
              onClick={() => {
                console.log('Estados', allData[selectedRow]);
                setContextMenu(null);
              }}
            >
              <span className="dt-resultados-context-icon">📊</span> Estados
            </button>
            <button
              className="dt-resultados-context-item"
              onClick={() => {
                console.log('Validar', allData[selectedRow]);
                setContextMenu(null);
              }}
            >
              <span className="dt-resultados-context-icon">✅</span> Validar
            </button>
          </div>
        </div>,
        document.body
      )}
      {showViewer && <DTViewer onClose={() => setShowViewer(false)} />}
    </div>,
    document.body
  );
}

export default DTResultados;
